/** Narrow UI intent in standard AG-UI state; never scientific component data. */
import type { ChatComponent } from "./assistant-components";
export type SelectionChoice = { representation: "pie" | "bar" } | { time_seconds: number | null };
export type SelectionProposal = SelectionChoice & { component_id: string; expected_revision: number };
export interface SelectionState { schema: "neoma.selection-state/1"; selections: SelectionProposal[] }
export const emptySelectionState = (): SelectionState => ({ schema: "neoma.selection-state/1", selections: [] });
function object(value: unknown): Record<string, unknown> {
  if (!value || typeof value !== "object" || Array.isArray(value)) throw new TypeError("Invalid selection state");
  return value as Record<string, unknown>;
}
export function parseSelectionState(value: unknown): SelectionState {
  const state = object(value), items = state.selections === undefined ? [] : state.selections;
  if (state.schema !== "neoma.selection-state/1" || Object.keys(state).some(k => !["schema", "selections"].includes(k)) || !Array.isArray(items) || items.length > 20) throw new TypeError("Invalid selection state");
  const seen = new Set<string>();
  const selections = items.map(value => {
    const p = object(value), keys = Object.keys(p).sort().join(",");
    if (typeof p.component_id !== "string" || !/^[a-z0-9]{15}$/.test(p.component_id) || seen.has(p.component_id) ||
      !Number.isSafeInteger(p.expected_revision) || Number(p.expected_revision) < 0 || Number(p.expected_revision) > 1e9) throw new TypeError("Invalid selection precondition");
    seen.add(p.component_id);
    if (keys === "component_id,expected_revision,representation" && ["pie", "bar"].includes(String(p.representation))) return p as unknown as SelectionProposal;
    if (keys === "component_id,expected_revision,time_seconds" && (p.time_seconds === null ||
      (typeof p.time_seconds === "number" && Number.isFinite(p.time_seconds) && p.time_seconds >= 0 && p.time_seconds <= 604800))) return p as unknown as SelectionProposal;
    throw new TypeError("Unsupported selection choice");
  });
  return { schema: "neoma.selection-state/1", selections: selections.sort((a, b) => a.component_id < b.component_id ? -1 : 1) };
}
export function componentChoice(component: ChatComponent): SelectionChoice {
  if (component.payload?.type === "hypnogram") return { time_seconds: component.state.selection?.time_seconds ?? null };
  if (component.payload?.type === "sleep_stage_breakdown" && component.state.representation) return { representation: component.state.representation };
  throw new TypeError("Unsupported selection component");
}
export function proposalChoice(proposal: SelectionProposal): SelectionChoice {
  return "representation" in proposal ? { representation: proposal.representation } : { time_seconds: proposal.time_seconds };
}
